import apiPayment from "../paymentApi";
import apiSubscription from "../subscriptionApi";

import {
  activeSubscriptionLoaded,
  activeSubscriptionLoading,
  activeSubscriptionLoadingError,
  pricingTableLoaded,
  pricingTableLoading,
  pricingTableLoadingError,
} from "./subscriptionStateActions";

// export const fetchSubscriptionPlan = createAsyncThunk(
//   "subscription/fetchSubscriptionPlan",
//   async () => {
//     return dispacth apiPayment.getPricingTable();
//   }
// );

// export function fetchSubscriptionPlans() {
//   return function (dispatch: any) {
//     dispatch(pricingTableLoading());
//     apiPayment.getPlansGroupedByInterval().then(
//       (data: any) => {
//         console.log(data);
//         dispatch(pricingTableLoaded(data));
//       },
//       function (error: any) {
//         console.error(error);
//         return dispatch(pricingTableLoadingError());
//       }
//     );
//   };
// }

export function getActiveSubscription() {
  return function (dispatch: any) {
    dispatch(activeSubscriptionLoading());
    apiSubscription.getActiveSubscription().then(
      (data: any) => {
        dispatch(activeSubscriptionLoaded(data));
      },
      function (error: any) {
        console.error(error);
        return dispatch(activeSubscriptionLoadingError());
      }
    );
  };
}

export function createCustomerPortalSession() {
  return function (dispatch: any) {
    return apiSubscription.createCustomerPortalSession().then(
      (url: string) => {
        window.location.href = url;
        // window.open(url, "_blank") || window.location.replace(url);
      },
      (error: any) => {
        console.error("Portal session error:", error);
      }
    );
  };
}
